export default __webpack_public_path__ + "static/media/ensinio_logo.091f7974.svg";